// NOTE(jpr): inspired by https://stackoverflow.com/a/39419171/1273175 to allow
// compiler-enforced exhaustive switch statements
export function assertUnreachable(_x: never): never {
  throw new Error('This should not be possible');
}
